import { DateTimeFactory } from "../../../../../../localization/useDateTime"
import { ClosingTimeType, CreateRoomResource, CreateRoomResourceForm, IntegrationType } from "../../resourcesTypes"

export const transformRoomFormToResource = (
    form: CreateRoomResourceForm,
    dateTimeFactory: DateTimeFactory,
): CreateRoomResource => {
    const { closingTimesDaily, bookingTime, integrationType, bookingTimeType, integrationEmailAddress, ...rest } = form
    const isAcceptBooking = bookingTimeType === "acceptBookingTime"

    const closingTimes = form.closingTimes
        .filter((time) => {
            if (time.type === ClosingTimeType.DAILY) return !isAcceptBooking
            return true
        })
        .map((time) => {
            if (time.type === ClosingTimeType.DAILY && !isAcceptBooking && closingTimesDaily) {
                return {
                    ...time,
                    periodInTime: {
                        from: dateTimeFactory.toHourMinute(closingTimesDaily.periodInTime?.from),
                        to: dateTimeFactory.toHourMinute(closingTimesDaily.periodInTime?.to),
                    },
                }
            }
            return time
        })

    const integrations =
        integrationType !== IntegrationType.NONE
            ? [
                  {
                      type: integrationType,
                      emailAddress: integrationEmailAddress,
                  },
              ]
            : []

    return {
        ...rest,
        closingTimes,
        integrations,
        bookingTime:
            isAcceptBooking && bookingTime
                ? {
                      periodInTime: {
                          from: dateTimeFactory.toHourMinute(bookingTime.periodInTime?.from),
                          to: dateTimeFactory.toHourMinute(bookingTime.periodInTime?.to),
                      },
                  }
                : undefined,
    }
}
